import { render, staticRenderFns } from "./caseretrieval.vue?vue&type=template&id=6b8ea76f&scoped=true&lang=pug"
import script from "./caseretrieval.vue?vue&type=script&lang=ts"
export * from "./caseretrieval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ea76f",
  null
  
)

export default component.exports